import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <section className="grid min-h-[32rem] place-items-center p-6 text-center">
      <div>
        <p className="font-mono text-[9px] tracking-[0.25em] text-zinc-700">
          ERROR // 404
        </p>
        <h1 className="mt-5 text-4xl font-light uppercase tracking-[-0.04em] text-zinc-100 sm:text-6xl">
          Route not found.
        </h1>
        <p className="mx-auto mt-5 max-w-md text-sm font-light leading-7 text-zinc-500">
          The requested interface does not exist or the project slug has changed.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block border border-zinc-700 px-4 py-3 font-mono text-[9px] tracking-[0.16em] text-zinc-400 transition-colors hover:border-zinc-100 hover:bg-zinc-100 hover:text-black focus-visible:border-zinc-100 focus-visible:bg-zinc-100 focus-visible:text-black focus-visible:outline-none"
        >
          RETURN HOME
        </Link>
      </div>
    </section>
  );
}
